import Loader from '@piconetworks/module-loader'
// import Loader from 'common/picore/src/packages/Modules/Loader/index'

/* eslint-disable-next-line import/no-cycle */
import createDuck from '../baseDuck'

const loader = Loader({
    createDuck,
})

loader.selectors.articleId = (state) => {
    const topScopeLoader = state?.loader?.user || state?.loader?.guest || {}
    const articleId = topScopeLoader?.article?.id
    if (articleId) {
        return articleId
    }
    return null
}

loader.selectors.promptTriggerRuleId = (state) => {
    const topScopeLoader = state?.loader?.user || state?.loader?.guest || {}
    const ruleId = topScopeLoader?.pricing?.identification?.identification_rule_id
    if (ruleId) {
        return ruleId
    }
    return null
}

loader.selectors.promptTriggerPlanId = (state) => {
    const topScopeLoader = state?.loader?.user || state?.loader?.guest || {}
    const planId = topScopeLoader?.pricing?.monetization?.plan_id
    if (planId) {
        return planId
    }
    return null
}

export default loader
